import { DeferredPromise } from '#src/utils/promise';
import { useCallback, useState } from 'react';

export const useDeferred = () => {
  const [result, setResult] = useState(new DeferredPromise());

  const reset = useCallback(() => {
    setResult(new DeferredPromise());
  }, []);

  return {
    result,
    promise: result?.promise,
    resolve: result?.resolve.bind(result),
    reject: result?.reject.bind(result),
    reset,
    isFulfilled: result.isFulfilled,
    isRejected: result.isRejected,
  };
};
